<template>

  <v-navigation-drawer app clipped fixed v-model="drawer">

    <v-list class="pt-2" two-line>
      <v-list-tile :to="{ path: '/notificaciones' }">
        <v-list-tile-action>
          <v-icon large>notifications</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Notificaciones</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile :to="{ path: '/extracto' }">
        <v-list-tile-action>
          <v-icon large>euro_symbol</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Extracto de movimientos</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile :to="{ path: '/liquidaciones' }">
        <v-list-tile-action>
          <v-icon large>pageview</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Consulta de liquidaciones</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile :to="{ path: '/incidencias' }">
        <v-list-tile-action>
          <v-icon large>build</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Incidencias</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile v-if="cuestionarios.length != 0" :to="{ path: '/cuestionarios' }">
        <v-list-tile-action>
          <v-badge overlap color="red">
            <span slot="badge" v-if="cuestionarios.length != 0">{{ cuestionarios.length }}</span>  
            <v-icon large>assignment</v-icon>
          </v-badge>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Cuestionarios pendientes</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-divider></v-divider>

      <v-subheader>Documentos de la comunidad</v-subheader>

      <v-list-tile
        v-for="carpeta in carpetas"
        :key="carpeta.NOMBRE"
        :to="{ path: '/documentos/' + carpeta.NOMBRE }">
      
        <v-list-tile-action>
          <v-badge overlap color="red">
            <span slot="badge" v-if="carpeta.NUMERO_DOCS_PENDIENTES != 0">{{ carpeta.NUMERO_DOCS_PENDIENTES }}</span>  
            <v-icon large>inbox</v-icon>
          </v-badge>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title>{{ carpeta.NOMBRE }}</v-list-tile-title>
          <v-list-tile-sub-title v-if="carpeta.NUMERO_DOCS_PENDIENTES != 0">Documentos nuevos</v-list-tile-sub-title>
        </v-list-tile-content>
        
      </v-list-tile>

      
    </v-list>
  </v-navigation-drawer>
</template>

<style>
</style>

<script>
  import { mapState } from 'vuex'
  import { USER_SET_DRAWER } from '../store/actions/user';

  export default {
    name: 'drawer',
    data: function () {
      return {}
    },
    computed: {
      drawer: {
        get() {
          return this.$store.getters.drawer
        },
        set(value) {
          this.$store.dispatch(USER_SET_DRAWER, value)
        }
      },
      ...mapState({
        authLoading: state => state.auth.status === 'loading',
        carpetas: state => state.documentos.carpetas,
        cuestionarios: state => state.cuestionarios.cuestionarios
      })
    },
  }
</script>